module.exports = __webpack_public_path__ + "static/media/Polygon-2.b4a04f66.svg";